import Bugsnag from '@bugsnag/js';

export function setUser(id: string, email: string, name: string) {
  Bugsnag.setUser(id, email, name);
}

export function reportHandledError(e: Error) {
  Bugsnag.notify(e);
}
